import { AppSelectBox } from 'components';
import useStreams from 'hooks/API/GET/useStreams';
import { Fragment } from 'react';

function StreamsDropDown({
  enableAPI,
  value,
  handleChange,
  fieldErrors = {},
  dependencies = {},
  labelClass,
  defaultLook = true,
}) {
  const { query = '' } = dependencies;
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;
  const { data, isLoading, isError } = useStreams({ enabled: enableAPI, queryParams });

  return (
    <AppSelectBox
      labelProps={{ label: 'Stream', className: labelClass }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
      options={data?.data?.map((option) => {
        return {
          label: option.name,
          value: option._id,
        };
      })}
      onChangeEvent={(args) => {
        if (args.value) handleChange({ target: { value: args.value } }, args);
      }}
      defaultLook={defaultLook}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

StreamsDropDown.defaultProps = {
  handleChange: () => {},
};

export default StreamsDropDown;
